import { render, staticRenderFns } from "./ProjectSection.vue?vue&type=template&id=20a70cf6&"
import script from "./ProjectSection.vue?vue&type=script&lang=js&"
export * from "./ProjectSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports